import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    isBuyline: false,
  },
};

const financeSlice = createSlice({
  name: "finance",
  initialState,
  reducers: {
    setFinanceData: (state, action) => {
      state.data.isBuyline = action.payload;
    },
  },
});

export const { setFinanceData } = financeSlice.actions;

export default financeSlice.reducer;
